// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","843":"teamwork"}[chunkId] || chunkId) + "." + {"216":"07a71d43","483":"4b220183","594":"0f1722c7","843":"fd37b240"}[chunkId] + ".js";
};